// Utilidades básicas
function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

// Recarga si hay una sessionStorage previa
if (sessionStorage.getItem('miSessionData')) {
  location.reload();
  sessionStorage.removeItem('miSessionData');
}

// Guardar session al hacer clic en el botón de checkout del drawer
document.addEventListener('click', function (e) {
  const target = e.target.closest('#CartDrawer-Checkout');
  if (target) {
    sessionStorage.setItem('miSessionData', "valorEjemplo");
  }
});

// Focus y accesibilidad para summaries
document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));
  if (summary.nextElementSibling?.id) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }
  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });
  if (summary.closest('header-drawer, menu-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {

  let elements = getFocusableElements(container);
  let first = elements[0];
  let last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (event.target !== container && event.target !== last && event.target !== first) return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if ((event.target === container || event.target === first) && event.shiftKey) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();

  if (
    elementToFocus.tagName === 'INPUT' &&
    ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
    elementToFocus.value
  ) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(':focus-visible');
} catch (e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = [
    'ARROWUP',
    'ARROWDOWN',
    'ARROWLEFT',
    'ARROWRIGHT',
    'TAB',
    'ENTER',
    'SPACE',
    'ESCAPE',
    'HOME',
    'END',
    'PAGEUP',
    'PAGEDOWN',
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener(
    'focus',
    () => {
      if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add('focused');
    },
    true
  );
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true });
    this.input.addEventListener('change', this.onInputChange.bind(this));
    this.querySelectorAll('button').forEach((button) =>
      button.addEventListener('click', this.onButtonClick.bind(this))
    );
    this.quantityUpdateUnsubscriber = undefined;
  }


  connectedCallback() {
    this.validateQtyRules();
    this.quantityUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.quantityUpdate, this.validateQtyRules.bind(this));
  }

  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }
  }

  onInputChange(event) {
    this.validateQtyRules();
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }

  validateQtyRules() {
    const value = parseInt(this.input.value);
    if (this.input.min) {
      const min = parseInt(this.input.min);
      const buttonMinus = this.querySelector(".quantity__button[name='minus']");
      buttonMinus.classList.toggle('disabled', value <= min);
    }
    if (this.input.max) {
      const max = parseInt(this.input.max);
      const buttonPlus = this.querySelector(".quantity__button[name='plus']");
      buttonPlus.classList.toggle('disabled', value >= max);
    }
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function throttle(fn, delay) {
  let lastCall = 0;
  return function (...args) {
    const now = new Date().getTime();
    if (now - lastCall < delay) {
      return;
    }
    lastCall = now;
    return fn(...args);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: `application/${type}` },
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (let i = 0, count = selector.options.length; i < count; i++) {
    let option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent('on' + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  let method = options['method'] || 'post';
  let params = options['parameters'] || {};

  let form = document.createElement('form');
  form.setAttribute('method', method);
  form.setAttribute('action', path);

  for (let key in params) {
    let hiddenField = document.createElement('input');
    hiddenField.setAttribute('type', 'hidden');
    hiddenField.setAttribute('name', key);
    hiddenField.setAttribute('value', params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (country_domid, province_domid, options) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler, this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    let value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    let value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    let opt = this.countryEl.options[this.countryEl.selectedIndex];
    let raw = opt.getAttribute('data-provinces');
    let provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (let i = 0; i < provinces.length; i++) {
        let opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = '';
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (let i = 0, count = values.length; i < values.length; i++) {
      let opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach((summary) =>
      summary.addEventListener('click', this.onSummaryClick.bind(this))
    );
    this.querySelectorAll('button:not(.localization-selector)').forEach((button) =>
      button.addEventListener('click', this.onCloseButtonClick.bind(this))
    );
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary'))
      : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest('.has-submenu');
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);

      if (window.matchMedia('(max-width: 990px)')) {
        document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
      }
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        parentMenuElement && parentMenuElement.classList.add('submenu-open');
        !reducedMotion || reducedMotion.matches
          ? addTrapFocus()
          : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove('menu-opening');
    this.mainDetailsToggle.querySelectorAll('details').forEach((details) => {
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
    });
    this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach((submenu) => {
      submenu.classList.remove('submenu-open');
    });
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);

    if (event instanceof KeyboardEvent) elementToFocus?.setAttribute('aria-expanded', false);
  }

  onFocusOut() {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement))
        this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest('.submenu-open');
    parentMenuElement && parentMenuElement.classList.remove('submenu-open');
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus(detailsElement.querySelector('summary'));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.querySelector('.section-header');
    this.borderOffset =
      this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty(
      '--header-bottom-position',
      `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
    );
    this.header.classList.add('menu-open');

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    window.addEventListener('resize', this.onResize);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    if (!elementToFocus) return;
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove('menu-open');
    window.removeEventListener('resize', this.onResize);
  }

  onResize = () => {
    this.header &&
      document.documentElement.style.setProperty(
        '--header-bottom-position',
        `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
      );
    document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
  };
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener('click', this.hide.bind(this, false));
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      // this.addEventListener('pointerup', (event) => {
      //   if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      // });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {

    document.body.classList.remove('overflow-hidden');
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    this.removeAttribute('open');
    //removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
      if (focus) deferredElement.focus();
      if (deferredElement.nodeName == 'VIDEO' && deferredElement.getAttribute('autoplay')) {
        // force autoplay for safari
        deferredElement.play();
      }
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();

    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = true;
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    this.isDragging = false;
    this.justDragged = false;


    if (!this.slider || !this.nextButton) return;
    if (this.classList.contains('thumbnail-slider')) {
      this.setupCenterMode();
    }

    // Scroll por arrastre solo en desktop
    let isDown = false;
    let startX;
    let scrollLeft;

    this.slider.addEventListener('mousedown', (e) => {
      if (window.innerWidth <= 768) return;
      isDown = true;
      this.slider.classList.add('dragging');
      startX = e.pageX - this.slider.offsetLeft;
      scrollLeft = this.slider.scrollLeft;
    });

    this.slider.addEventListener('mouseleave', () => {
      isDown = false;
      this.slider.classList.remove('dragging');
    });

    this.slider.addEventListener('mouseup', () => {
      isDown = false;
      this.slider.classList.remove('dragging');
    });

    this.slider.addEventListener('mousemove', (e) => {
      if (!isDown || window.innerWidth <= 768) return;
      e.preventDefault();
      const x = e.pageX - this.slider.offsetLeft;
      const walk = (x - startX) * 1;
      this.slider.scrollLeft = scrollLeft - walk;
    });

    this.initPages();
    const resizeObserver = new ResizeObserver(() => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    if (this.classList.contains('main-slider')) {
      this.slider.addEventListener('scroll', this.syncThumbnailSlider.bind(this));
    }
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));

  }

  syncThumbnailSlider() {
    const thumbnailSlider = document.querySelector('slider-component.thumbnail-slider');
    if (!thumbnailSlider) return;

    const mainIndex = Array.from(this.sliderItems).findIndex((item) => {
      const itemCenter = item.offsetLeft + item.clientWidth / 2;
      const sliderCenter = this.slider.scrollLeft + this.slider.clientWidth / 2;
      return Math.abs(itemCenter - sliderCenter) < item.clientWidth / 2;
    });

    if (mainIndex >= 0) {
      thumbnailSlider.scrollToCenter(mainIndex);
    }
  }

  setupCenterMode() {
    this.visibleItems = 4;

    // Click para centrar el item
    this.sliderItems.forEach((item, index) => {
      item.style.flex = `0 0 ${100 / this.visibleItems}%`;
      item.addEventListener('click', () => {
        this.scrollToCenter(index);
        this.syncMainSlider(index);  // Sincroniza el slider principal al hacer clic
      });
    });
  }

  scrollToCenter(index) {
    const totalItems = this.sliderItems.length;
    const item = this.sliderItems[index];
    let scrollPosition;

    if (index === 0) {
      scrollPosition = 0;
    } else if (index >= totalItems - 1) {
      scrollPosition = this.slider.scrollWidth - this.slider.clientWidth;
    } else {
      const centerOffset = (this.slider.clientWidth - item.clientWidth) / 2;
      scrollPosition = item.offsetLeft - centerOffset;
    }

    this.slider.scrollTo({
      left: scrollPosition,
      behavior: 'smooth',
    });
  }

  // Sincroniza el slider principal al hacer clic en las miniaturas
  syncMainSlider(index) {
    const mainSlider = document.querySelector('.main-slider'); // Aquí seleccionamos el slider principal
    const mainSliderItems = mainSlider.querySelectorAll('.main-slide'); // Aquí asumimos que los items en el slider principal tienen la clase .main-slide

    if (mainSlider && mainSliderItems.length > 0) {
      const mainItem = mainSliderItems[index];
      mainSlider.scrollTo({
        left: mainItem.offsetLeft
      });
    }
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter((element) => element.clientWidth > 0);
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor(
      (this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset
    );
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
    setTimeout(() => {
      this.initPages();
    }, 800);
  }

  update() {
    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage !== previousPage) {
      this.dispatchEvent(
        new CustomEvent('slideChanged', {
          detail: {
            currentPage: this.currentPage,
            currentElement: this.sliderItemsToShow[this.currentPage - 1],
          },
        })
      );
    }
  }

  onButtonClick(event) {
    const step = event.currentTarget.dataset.step || 1;

    if (event.currentTarget.name === 'next') {
      this.slideScrollPosition = this.slider.scrollLeft + step * this.sliderItemOffset;
    } else {
      this.slideScrollPosition = this.slider.scrollLeft - step * this.sliderItemOffset;
    }

    this.setSlidePosition(this.slideScrollPosition);
  }

  setSlidePosition(position) {
    this.slider.scrollTo({
      left: position
    });
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
    return element.offsetLeft + element.clientWidth <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
  }

  connectedCallback() {
    this.resetSlider();
  }

  resetSlider() {
    // Reconfigurar todos los elementos relevantes del slider
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();

    // Reconfigurar los eventos de scroll
    this.slider.removeEventListener('scroll', this.update.bind(this));
    this.slider.addEventListener('scroll', this.update.bind(this));

    // Reconfigurar eventos de navegación
    this.prevButton.removeEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.removeEventListener('click', this.onButtonClick.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));

    // Reconfigurar el modo centrado si es necesario
    if (this.classList.contains('thumbnail-slider')) {
      this.setupCenterMode();
    }

    // Reconfigurar la sincronización de miniaturas
    if (this.classList.contains('main-slider')) {
      this.slider.removeEventListener('scroll', this.syncThumbnailSlider.bind(this));
      this.slider.addEventListener('scroll', this.syncThumbnailSlider.bind(this));
    }
  }
}

customElements.define('slider-component', SliderComponent);



class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector('.slider-buttons');
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.announcementBarSlider = this.querySelector('.announcement-bar-slider');
    // Value below should match --duration-announcement-bar CSS value
    this.announcerBarAnimationDelay = this.announcementBarSlider ? 250 : 0;

    this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
    this.sliderControlLinksArray.forEach((link) => link.addEventListener('click', this.linkToSlide.bind(this)));
    this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
    this.setSlideVisibility();
    if (this.announcementBarSlider) {
      this.announcementBarArrowButtonWasClicked = false;

      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.reducedMotion.addEventListener('change', () => {
        if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
      });

      [this.prevButton, this.nextButton].forEach((button) => {
        button.addEventListener(
          'click',
          () => {
            this.announcementBarArrowButtonWasClicked = true;
          },
          { once: true }
        );
      });
    }

    if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
  }

  setAutoPlay() {
    this.autoplaySpeed = this.slider.dataset.speed * 1000;
    this.addEventListener('mouseover', this.focusInHandling.bind(this));
    this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
    this.addEventListener('focusin', this.focusInHandling.bind(this));
    this.addEventListener('focusout', this.focusOutHandling.bind(this));

    if (this.querySelector('.slideshow__autoplay')) {
      this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
      this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
      this.autoplayButtonIsSetToPlay = true;
      this.play();
    } else {
      this.reducedMotion.matches || this.announcementBarArrowButtonWasClicked
        ? this.pause()
        : this.play();
    }
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    this.wasClicked = true;

    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) {
      this.applyAnimationToAnnouncementBar(event.currentTarget.name);
      return;
    }

    if (isFirstSlide && event.currentTarget.name === 'previous') {
      this.slideScrollPosition =
        this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === 'next') {
      this.slideScrollPosition = 0;
    }

    this.setSlidePosition(this.slideScrollPosition);

    this.applyAnimationToAnnouncementBar(event.currentTarget.name);
  }

  setSlidePosition(position) {
    if (this.setPositionTimeout) clearTimeout(this.setPositionTimeout);
    this.setPositionTimeout = setTimeout(() => {
      this.slider.scrollTo({
        left: position,
      });
    }, this.announcerBarAnimationDelay);
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
    this.prevButton.removeAttribute('disabled');
    if (!this.sliderControlButtons.length) return;
    this.sliderControlButtons.forEach((link) => {
      link.classList.remove('slider-counter__link--active');
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
      if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
      this.play();
    } else if (
      !this.reducedMotion.matches &&
      !this.announcementBarArrowButtonWasClicked
    ) {
      this.play();
    }
  }

  focusInHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
      if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
        this.play();
      } else if (this.autoplayButtonIsSetToPlay) {
        this.pause();
      }
    } else if (this.announcementBarSlider.contains(event.target)) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute('aria-live', 'off');
    clearInterval(this.autoplay);
    this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
  }

  pause() {
    this.slider.setAttribute('aria-live', 'polite');
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow);
    } else {
      this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow);
    }
  }

  autoRotateSlides() {
    const slideScrollPosition =
      this.currentPage === this.sliderItems.length
        ? 0
        : this.slider.scrollLeft + this.sliderItemOffset;

    this.setSlidePosition(slideScrollPosition);
    this.applyAnimationToAnnouncementBar();

  }

  setSlideVisibility(event) {
    this.sliderItemsToShow.forEach((item, index) => {
      const linkElements = item.querySelectorAll('a');
      if (index === this.currentPage - 1) {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.removeAttribute('tabindex');
          });
        item.setAttribute('aria-hidden', 'false');
        item.removeAttribute('tabindex');
      } else {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.setAttribute('tabindex', '-1');
          });
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('tabindex', '-1');
      }
    });
    this.wasClicked = false;
  }

  applyAnimationToAnnouncementBar(button = 'next') {
    if (!this.announcementBarSlider) return;

    const itemsCount = this.sliderItems.length;
    const increment = button === 'next' ? 1 : -1;

    const currentIndex = this.currentPage - 1;
    let nextIndex = (currentIndex + increment) % itemsCount;
    nextIndex = nextIndex === -1 ? itemsCount - 1 : nextIndex;

    const nextSlide = this.sliderItems[nextIndex];
    const currentSlide = this.sliderItems[currentIndex];

    const animationClassIn = 'announcement-bar-slider--fade-in';
    const animationClassOut = 'announcement-bar-slider--fade-out';

    const isFirstSlide = currentIndex === 0;
    const isLastSlide = currentIndex === itemsCount - 1;

    const shouldMoveNext = (button === 'next' && !isLastSlide) || (button === 'previous' && isFirstSlide);
    const direction = shouldMoveNext ? 'next' : 'previous';

    currentSlide.classList.add(`${animationClassOut}-${direction}`);
    nextSlide.classList.add(`${animationClassIn}-${direction}`);

    setTimeout(() => {
      currentSlide.classList.remove(`${animationClassOut}-${direction}`);
      nextSlide.classList.remove(`${animationClassIn}-${direction}`);
    }, this.announcerBarAnimationDelay * 2);
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition =
      this.slider.scrollLeft +
      this.sliderFirstItemNode.clientWidth *
      (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }
}

customElements.define('slideshow-component', SlideshowComponent);

/* Event change ------------------------------------------------------------> */
class VariantSelects extends HTMLElement {
  constructor() {
    super();
    //this.addEventListener('click', this.onVariantChange.bind(this));
    this.addEventListener('change', this.onVariantChange);
  }

  connectedCallback() {
    this.changeAvailableDisabled();
    this.updateListChange();
  }

  onVariantChange(event) {
    this.updateDescriptionLeather(event);
    this.updateOptions(event.target);
    this.updateMasterId(event.target);
    this.updateColors(event.target);
    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();
    this.removeErrorMessage();
    this.updateVariantStatuses();
    this.updateCallOuts(event.currentTarget.options);

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      // this.setUnavailable();
    } else {

      if (event.target.closest('.card-variant')) {
        this.updateImageCard(event.target.closest('.card-variant'))
        this.updateVariantInput();
        this.updateShareUrl();
        this.renderProductInfo();//render info products rendereing

        return;
      }

      this.updateVariantInput();
      this.updateURL();
      this.renderProductInfo();//render info products rendereing
      this.updateShareUrl();
    }

    if (event.target.closest('.options-variants')) {
      const selectedValue = event.target.value;
      const parent = event.target.closest('.options-variants');
      const inputToCheck = parent.querySelector('input[name="Size"][value="' + selectedValue + '"]');

      if (inputToCheck) {
        inputToCheck.checked = true;
      }
    }
  }

  updateDescriptionLeather(event) {
    if (event.target.getAttribute("name") === "Leather Type") {
      const specificationsAccordion = document.querySelector(".accordion__content--specifications .TableWrapper");
      if (!specificationsAccordion) return;
      const leatherType = event.target.value === "Premium" ? { old: "Supreme", new: "Premium" } : { old: "Premium", new: "Supreme" };
      specificationsAccordion.innerHTML = specificationsAccordion.innerHTML.replace(leatherType.old, leatherType.new);
    }
  }

  updateListChange() {
    const selectElement = this.querySelector('.selectMedida');

    if (selectElement) {
      const allInputs = selectElement.closest('.options-variants');
      const selectInit = allInputs.querySelectorAll('[name="Size"]');
      if (!selectInit[0]) return

      selectElement.addEventListener('change', function (event) {
        const selectedValue = event.target.value;
        const parent = event.target.closest('.options-variants');
        parent.querySelector('input[name="Size"][value="' + selectedValue + '"]').checked = true;

      });
    }
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  changeOptionColorOutStock(parent) {
    const isUpsellCart = parent.closest('.drawer__upsell');
    const variantSelectAll = parent.querySelectorAll('.select-compare-js');
    const variantTexts = Array.from(variantSelectAll).map(element => element.textContent);

    if (!variantTexts.length) return

    const optionsSelected = variantTexts.join(' / ');
    const variantsAll = JSON.parse(parent.querySelector('[type="application/json"]').textContent);

    const lstInputs = [...parent.querySelectorAll('.colors-js')];
    const listLabel = [...parent.querySelectorAll('.option-color')];

    lstInputs.forEach((color, index) => {

      const labelColor = listLabel[index];
      if (
        parent.dataset.colorSelectsStyle === 'true' &&
        labelColor?.dataset.colorCandidateEligible === 'true'
      ) {
        if (color.disabled && !parent.colorTierSwitchTriggered) {
          color.classList.add('hidden');
          labelColor.classList.add('hidden');
          labelColor.style.setProperty('display', 'none', 'important');
        } else {
          color.classList.remove('hidden');
          labelColor.classList.remove('hidden');
          labelColor.style.removeProperty('display');
        }
        return;
      }
      const option = `${color.value} / ${optionsSelected}`;

      const variantFind = variantsAll.find(findVariant => findVariant.title.trim() === option.trim());

      if (variantFind) {
        if (isUpsellCart) {
          const action = variantFind.available ? 'remove' : 'add';
          color.classList[action]('hidden');
          labelColor.classList[action]('hidden');
          return;
        }
        color.classList.remove('hidden');
        labelColor.classList.remove('hidden');

        return
      }

      color.classList.add('hidden');
      labelColor.classList.add('hidden');
    });

    this.pressInputFirst(parent);
  }

  changeAvailableDisabled(target) {
    if (target) {

      const parent = target.closest('variant-radios');
      this.changeOptionColorOutStock(parent);
      return;
    }
    const parents = document.querySelectorAll('variant-radios');

    if (parents.length === 0) return

    parents.forEach(parent => {

      if (!parent.querySelector('[data-selected="true"]')) return;

      this.changeOptionColorOutStock(parent);

    })
  }

  pressInputFirst(parent) {
    const inputs = parent.querySelectorAll('.colors-js:not(.hidden)');
    const checkedIndex = Array.from(inputs).findIndex(checkbox => checkbox.checked);
  }

  updateColors(target) {

    if (target.dataset.selected === "true") {
      this.changeAvailableDisabled(target);
      return
    }
  }

  updateMasterId(target = null) {

    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });

    return this.currentVariant;
  }

  updateURL() {
    if (document.querySelector(`#card-${this.dataset.section}-media`)) return

    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    // window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
    );
    productForms.forEach((productForm) => {

      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updateVariantStatuses() {

    const selectedOptionOneVariants = this.variantData.filter(
      (variant) => this.querySelector(':checked').value === variant.option1
    );
    const inputWrappers = [...this.querySelectorAll('.product-form__input')];
    inputWrappers.forEach((option, index) => {
      if (index === 0) return;
      const optionInputs = [...option.querySelectorAll('input[type="radio"], option')];
      const previousOptionSelected = inputWrappers[index - 1].querySelector(':checked').value;
      const availableOptionInputsValue = selectedOptionOneVariants
        .filter((variant) => variant.available && variant[`option${index}`] === previousOptionSelected)
        .map((variantOption) => variantOption[`option${index + 1}`]);
      this.setInputAvailability(optionInputs, availableOptionInputsValue);
    });
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
        input.innerText = input.getAttribute('value');
      } else {
        input.innerText = window.variantStrings.unavailable_with_option.replace('[value]', input.getAttribute('value'));
      }
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  updateImageCard(parent) {
    const requestedVariantId = this.currentVariant.id;

    const mediaCard = parent.querySelector(`#card-${this.dataset.section}-media`);

    const variants = this.getVariantData();
    const variantSelectd = variants.find((variant) => variant.id === requestedVariantId).featured_image;
    mediaCard.querySelector('.image-1').setAttribute('src', variantSelectd.src);
    mediaCard.querySelector('.image-1').setAttribute('srcset', variantSelectd.src);
  }

  renderProductInfo() {
    const requestedVariantId = this.currentVariant.id;
    const sectionId = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;
    fetch(
      `${this.dataset.url}?variant=${requestedVariantId}&section_id=main-product-fetch`
    )
      .then((response) => response.text())
      .then((responseText) => {
        // prevent unnecessary ui changes from abandoned selections
        if (this.currentVariant.id !== requestedVariantId) return;
        const html = new DOMParser().parseFromString(responseText, 'text/html');

        const ringType = document.getElementById(`ring-type-${this.dataset.section}`);
        const ringOldType = html.querySelector('.product-form__input.Ring.Type');

        const includePrice = document.getElementById(`price-box-new-${this.dataset.section}`);
        const includeOld = html.querySelector('.price-box-new');

        const ringPercent = document.getElementById(`tag-percent-${this.dataset.section}`);
        const ringPercentOld = html.querySelector('.tag-percent');

        const swiperNewPDP = document.getElementById(`swiper-test-money-clip-${this.dataset.section}`);
        const swiperOldPDP = html.querySelector('.swiper-test-money-clip');

        const sliderPrincipal = document.getElementById(`GalleryViewer-${this.dataset.section}`);
        const sliderPrincipalContent = html.querySelector('.swiper-main-media');

        const sliderTumbnail = document.getElementById(`tumbnail-main-${this.dataset.section}`);
        const sliderTumbnailContent = html.querySelector('.product__media-thumbnails');

        const destination = document.getElementById(`price-${this.dataset.section}`);
        const source = html.querySelector('.get-price');
        const savingsRibbonDestination = document.getElementById(`savings-ribbon-${this.dataset.section}`);
        const savingsRibbonSource = html.querySelector('.savings-ribbon');
        const destinationRibbon = document.getElementById(`content-image-ribbon-${this.dataset.section}`);
        const contentRibbon = html.querySelector('.content-image-ribbon');
        const cornerPDP = document.getElementById(`content-image-corner-${this.dataset.section}`);
        const cornerContent = html.querySelector('.content-image-corner');

        const destinationRibbontwo = document.getElementById(`content-image-ribbon-two-${this.dataset.section}`);
        const contentRibbontwo = html.querySelector('.content-image-ribbon-two');
        const cornerPDPtwo = document.getElementById(`content-image-corner-two-${this.dataset.section}`);
        const cornerContenttwo = html.querySelector('.content-image-corner-two');

        const bundlePDP = document.getElementById(`content-bundle-save-product-${this.dataset.section}`);
        const bundlePDPContent = html.querySelector('.content-bundle-save-product');

        const leatherPDP = document.getElementById(`custom-info-leather-${this.dataset.section}`);
        const leatherPDPContent = html.querySelector('.custom-info-leather');

        const skuSource = html.getElementById(
          `Sku-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const skuDestination = document.getElementById(`Sku-${this.dataset.section}`);
        const inventorySource = html.getElementById(
          `Inventory-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const inventoryDestination = document.getElementById(`Inventory-${this.dataset.section}`);

        const volumePricingSource = html.getElementById(
          `Volume-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );

        const pricePerItemDestination = document.getElementById(`Price-Per-Item-${this.dataset.section}`);
        const pricePerItemSource = html.getElementById(`Price-Per-Item-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
        const volumePricingDestination = document.getElementById(`Volume-${this.dataset.section}`);

        if (swiperOldPDP && swiperNewPDP) swiperNewPDP.innerHTML = swiperOldPDP.innerHTML;
        if (ringOldType && ringType) ringType.innerHTML = ringOldType.innerHTML;
        if (includeOld && includePrice) includePrice.innerHTML = includeOld.innerHTML;

        if (ringPercentOld && ringPercent) ringPercent.innerHTML = ringPercentOld.innerHTML;

        var ringTypeRadios = document.querySelectorAll('.ring-template input[name="Ring Type"]');

        ringTypeRadios.forEach(function (input) {
          // Busca el label asociado
          var label = document.querySelector('label[for="' + input.id + '"]');
          if (!label) return;

          // Busca el div de fondo dentro del label
          var swatchDiv = label.querySelector('div[class^="option_"]');
          if (!swatchDiv) return;

          // Evita duplicados si el span ya existe
          if (!swatchDiv.querySelector(".ring-type-text")) {
            var textSpan = document.createElement("span");
            textSpan.className = "ring-type-text";
            textSpan.innerText = input.value;
            // Insertar dentro del div
            swatchDiv.appendChild(textSpan);
          }
        });

        if (sliderPrincipal && sliderPrincipalContent) {
          // ✅ Reemplazar solo el contenido, no el nodo entero
          sliderPrincipal.innerHTML = sliderPrincipalContent.innerHTML;

          // 🔁 Reinicializar los slider-component que acaban de insertarse
          sliderPrincipal.querySelectorAll('.swiper-main-media').forEach((slider) => {
            const cloned = slider.cloneNode(true);
            slider.replaceWith(cloned); // Esto vuelve a ejecutar el Web Component
          });
        }

        if (sliderTumbnail && sliderTumbnailContent) {
          // ✅ Reemplazar solo el contenido, no el nodo entero
          sliderTumbnail.innerHTML = sliderTumbnailContent.innerHTML;

          // 🔁 Reinicializar los slider-component que acaban de insertarse
          sliderTumbnail.querySelectorAll('.product__media-thumbnails').forEach((slider) => {
            const cloned = slider.cloneNode(true);
            slider.replaceWith(cloned); // Esto vuelve a ejecutar el Web Component
          });
        }

        initSwipers();

        const testGroup = window.igData?.user?.getTestGroup("acc19760-1d78-4ea4-82c1-4c8f3aebaf70");
        const idTestIntelligems = testGroup ? testGroup.id : null;

        if (idTestIntelligems) {
          if (idTestIntelligems === 'b2eab2cc-37ee-4bea-befd-e47b5d2d7e53') {
            const oldScript = document.getElementById(`imagest-test-${this.dataset.section}`);
            const newScript = html.querySelector('.images-test');
            if (newScript && oldScript) oldScript.innerHTML = newScript.innerHTML;
            const scriptTag = document.querySelector('.images-test');
            if (scriptTag) {
              try {
                const parsedImages = JSON.parse(scriptTag.textContent);
                window.customVariantImages = parsedImages;
                initializeCustomSlider(parsedImages);
                initSwipers();
              } catch (e) {
                console.error('Initial load error:', e);
              }
            }
          }
        }


        if (source && destination) destination.innerHTML = source.innerHTML;
        if (savingsRibbonSource && savingsRibbonDestination) {
          savingsRibbonDestination.innerHTML = savingsRibbonSource.innerHTML;
        }
        if (leatherPDP && leatherPDPContent) leatherPDPContent.innerHTML = leatherPDP.innerHTML;
        if (contentRibbon && destinationRibbon) destinationRibbon.innerHTML = contentRibbon.innerHTML;
        if (cornerContent && cornerPDP) cornerPDP.innerHTML = cornerContent.innerHTML;

        if (contentRibbontwo && destinationRibbontwo) destinationRibbontwo.innerHTML = contentRibbontwo.innerHTML;
        if (cornerContenttwo && cornerPDPtwo) cornerPDPtwo.innerHTML = cornerContenttwo.innerHTML;

        if (bundlePDPContent && bundlePDP) bundlePDP.innerHTML = bundlePDPContent.innerHTML;
        if (inventorySource && inventoryDestination) inventoryDestination.innerHTML = inventorySource.innerHTML;
        if (skuSource && skuDestination) {
          skuDestination.innerHTML = skuSource.innerHTML;
          skuDestination.classList.toggle('visibility-hidden', skuSource.classList.contains('visibility-hidden'));
        }

        const dataLeather = leatherPDPContent.getAttribute("data-leather");
        const targetDiv = document.querySelector(".content-custom-leather");

        const matches = dataLeather
          .split("|")
          .map(part => part.trim())
          .filter(part => /leather/i.test(part)); // filtra los que contienen "leather" sin importar mayúsculas

        const lastLeather = matches[matches.length - 1];

        if (lastLeather) {
          targetDiv.textContent = `| ${lastLeather}`;
        }


        if (volumePricingSource && volumePricingDestination) {
          volumePricingDestination.innerHTML = volumePricingSource.innerHTML;
        }

        if (pricePerItemSource && pricePerItemDestination) {
          pricePerItemDestination.innerHTML = pricePerItemSource.innerHTML;
          pricePerItemDestination.classList.toggle('visibility-hidden', pricePerItemSource.classList.contains('visibility-hidden'));
        }

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove('visibility-hidden');

        if (inventoryDestination)
          inventoryDestination.classList.toggle('visibility-hidden', inventorySource.innerText === '');

        const addButtonUpdated = html.getElementById(`ProductSubmitButton-main-product-fetch`);
        this.toggleAddButton(
          addButtonUpdated ? addButtonUpdated.hasAttribute('disabled') : true,
          window.variantStrings.soldOut
        );
        publish(PUB_SUB_EVENTS.variantChange, {
          data: {
            sectionId,
            html,
            variant: this.currentVariant,
          },
        });
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButtons = productForm.querySelectorAll('[name="add"]');
    const addButtonTexts = productForm.querySelectorAll('[name="add"] > span');
    if (!addButtons) return;

    if (disable) {
      addButtons.forEach(button => {
        button.setAttribute('disabled', 'disabled');
      });
      if (text) {
        addButtonTexts.forEach(el => {
          el.textContent = text;
        });
      }
    } else {
      addButtons.forEach(button => {
        button.removeAttribute('disabled');
      });
      addButtonTexts.forEach(el => {
        if (el.closest('.drawer__upsell')) {
          el.textContent = "ADD To Cart";
          return;
        }
        el.textContent = window.variantStrings.addToCart;
      });
    }

    const stickyPDPButtonForm = document.querySelector('product-form.sticky-add-cart');
    if (stickyPDPButtonForm) {
      const stickyATCButton = stickyPDPButtonForm.querySelector('[name="add"]');
      const stickyATCButtonText = stickyPDPButtonForm.querySelector('[name="add"] > span');
      if (disable) {
        stickyATCButton.setAttribute('disabled', 'disabled');
        if (text) {
          stickyATCButtonText.textContent = text;
        }
      } else {
        stickyATCButton.removeAttribute('disabled');
        stickyATCButtonText.textContent = window.variantStrings.addToCart;
      }
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const stickyPDPButtonForm = document.querySelector('product-form.sticky-add-cart');
    const price = document.getElementById(`price-${this.dataset.section}`);
    const inventory = document.getElementById(`Inventory-${this.dataset.section}`);
    const sku = document.getElementById(`Sku-${this.dataset.section}`);
    const pricePerItem = document.getElementById(`Price-Per-Item-${this.dataset.section}`);

    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (stickyPDPButtonForm) {
      const stickyATCButtonText = stickyPDPButtonForm.querySelector('[name="add"] > span');
      stickyATCButtonText.textContent = window.variantStrings.unavailable;
    }
    if (price) price.classList.add('visibility-hidden');
    if (inventory) inventory.classList.add('visibility-hidden');
    if (sku) sku.classList.add('visibility-hidden');
    if (pricePerItem) pricePerItem.classList.add('visibility-hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
    this.addEventListener('click', (event) => {
      const element = event.target;
      const parent = element.closest('variant-radios');
      if (
        !event.isTrusted ||
        !element.matches('input.colors-js[type="radio"]') ||
        parent?.dataset.colorSelectsStyle !== 'true' ||
        parent.suppressColorTierSwitch
      ) return;

      this.colorTierSwitchClickHandled = element;
      setTimeout(() => {
        if (this.colorTierSwitchClickHandled === element) {
          this.colorTierSwitchClickHandled = null;
        }
      }, 0);
      this.switchColorTier(element);
    });
  }

  switchColorTier(element) {
    const parent = element.closest('variant-radios');
    if (
      parent?.dataset.colorSelectsStyle === 'true' &&
      !parent.suppressColorTierSwitch &&
      element.matches('input.colors-js[type="radio"]')
    ) {
      const label = Array.from(element.labels || []).find((candidate) => candidate.classList.contains('option-color'));
      const tier = label?.dataset.colorTier;
      if (tier) {
        const colorFieldset = element.closest('fieldset');
        const target = Array.from(parent.querySelectorAll('fieldset input[type="radio"][data-option-select]'))
          .find((radio) => radio.closest('fieldset') !== colorFieldset && radio.value === tier);
        if (target && !target.disabled && !target.checked) {
          parent.colorTierSwitchTriggered = true;
          setTimeout(() => target.click(), 10);
        }
      }
    }
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
        input.classList.remove('disabled');
      } else {
        input.classList.add('disabled');
      }
    });
  }

  updateOptions(element) {

    const parent = element.closest('variant-radios');
    if (this.colorTierSwitchClickHandled === element) {
      this.colorTierSwitchClickHandled = null;
    } else {
      this.switchColorTier(element);
    }
    const fieldsets = Array.from(parent.querySelectorAll('fieldset'));

    this.options = fieldsets.map((fieldset) => {

      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked)?.value;
    });

    parent.querySelectorAll('input').forEach((radio) => {
      if (radio.checked) {
        radio.closest('fieldset').querySelector('.option-selected-js').textContent = radio.value;
      }
    });

  }

  updateCallOuts(options) {
    const titles = document.querySelectorAll('.property-title');
    if (!titles || titles.length === 0) return;
    const callOut = titles && titles[1].querySelector('strong');

    // if (options.find(option => option === "Supreme")) {
    //   callOut.innerHTML = callOut.innerHTML.replace("Premium", callOut.dataset.supreme);
    // } else if (options.find(option => option === "Premium")) {
    //   callOut.innerHTML = callOut.innerHTML.replace("Supreme", callOut.dataset.premium);
    // }
  }
}

customElements.define('variant-radios', VariantRadios);

class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {

    this.initFetch();
  }

  initFetch() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      fetch(this.dataset.url)
        .then((response) => response.text())
        .then((text) => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('product-recommendations');

          const result = recommendations.querySelector('.elements-js');
          const container = document.querySelector('.elements-js');

          if (!this.classList.contains('related-products')) container.append(...result.children);
        })
        .catch((e) => {
          console.error(e);
        });
    };

    new IntersectionObserver(handleIntersection.bind(this), { rootMargin: '0px 0px 400px 0px' }).observe(this);
  }
}

customElements.define('product-recommendations', ProductRecommendations);

window.addEventListener('DOMContentLoaded', (event) => {
  document.querySelectorAll('facet-filters-form details.facets__disclosure-vertical').forEach(item => {
    if (!item.hasAttribute('open')) {
      item.querySelector('summary').click()
    }
  })

  defer(addReviewStar);

  function defer(method) {
    const stampedBadge = document.querySelector('.stamped-badge');
    if (window.$ && stampedBadge) {
      method();
    } else {
      setTimeout(function () { defer(method) }, 50);
    }
  }

  function addReviewStar() {
    // Agregar clase a la última estrella dentro de .stamped-badge
    const lastStar = document.querySelector('.stamped-badge .stamped-fa-star:last-child');
    if (lastStar) lastStar.classList.add('stamped-fa-star-half-o');

    // Agregar clase 'show' a todos los elementos .stamped-badge
    document.querySelectorAll('.stamped-badge').forEach(badge => {
      badge.classList.add('show');
    });

    // Toggle para .selector-open p y sus padres
    document.querySelectorAll('.selector-open p').forEach(p => {
      p.addEventListener('click', function () {
        this.classList.toggle('active');
        if (this.parentElement) this.parentElement.classList.toggle('active');
        if (this.parentElement && this.parentElement.parentElement && this.parentElement.parentElement.parentElement) {
          this.parentElement.parentElement.parentElement.classList.toggle('active');
        }
      });
    });

    // Abrir menú móvil
    const navToggle = document.getElementById('nav-toggle');
    if (navToggle) {
      navToggle.addEventListener('click', function () {
        const headerNav = document.getElementById('header-kings__navigation');
        if (headerNav) headerNav.setAttribute('data-show', 'true');
      });
    }

    // Cerrar menú móvil
    document.querySelectorAll('.header-kings-nav-mobile--close').forEach(closeBtn => {
      closeBtn.addEventListener('click', function () {
        const headerNav = document.getElementById('header-kings__navigation');
        if (headerNav) headerNav.setAttribute('data-show', 'false');
      });
    });
  }

  // Menú móvil hamburger
  document.querySelectorAll('.custom-hamburger-menu').forEach(el => {
    el.addEventListener('click', function () {
      document.getElementById('header-kings__navigation').setAttribute('data-show', 'true');
      setTimeout(() => document.body.classList.add('no_scroll'), 800);
      window.igEvents = window.igEvents || [];
      window.igEvents.push({ "event": 'Menu PDP Sticky Clicked' });
    });
  });
  document.querySelectorAll('.float-navbar .float-navbar__icon--menu').forEach(el => {
    el.addEventListener('click', function () {
      document.getElementById('header-kings__navigation').setAttribute('data-show', 'true');
      setTimeout(() => document.body.classList.add('no_scroll'), 800);
    });
  });

  // Abrir/cerrar barra de búsqueda mobile
  const openHeader = document.getElementById('open-header');
  if (openHeader) {
    openHeader.addEventListener('click', function (event) {
      event.stopPropagation();
      document.querySelector('.header-kings__search').classList.toggle('open-search');
      document.body.classList.toggle('overlayer');
    });
  }
  document.querySelectorAll('.icon-search-mobile').forEach(el => {
    el.addEventListener('click', function (event) {
      event.stopPropagation();
      document.querySelector('.header-kings__search').classList.toggle('open-search');
      document.body.classList.toggle('overlayer');
    });
  });
  const rpCart = document.getElementById('rp-cart');
  if (rpCart) {
    rpCart.addEventListener('click', function () {
      document.getElementById('cart-icon-bubble').click();
    });
  }
  document.querySelectorAll('.float-navbar .float-navbar__icon--search').forEach(el => {
    el.addEventListener('click', function (event) {
      event.stopPropagation();
      window.scrollTo({ top: 0, behavior: 'smooth' });
      document.querySelector('.header-kings__search').classList.toggle('open-search');
      document.body.classList.toggle('overlayer');
    });
  });
  document.addEventListener('click', function (event) {
    if (!event.target.closest('.header-kings__search-form')) {
      document.querySelector('.header-kings__search')?.classList.remove('open-search');
      document.body.classList.remove('overlayer');
    }
  });
  document.querySelectorAll('.close-search').forEach(el => {
    el.addEventListener('click', function () {
      document.querySelector('.header-kings__search').classList.remove('open-search');
      document.body.classList.remove('overlayer');
    });
  });

  // sticky header
  window.addEventListener('scroll', function () {
    const scrollTop = window.scrollY;
    const windowHeight = window.innerHeight;
    const documentHeight = document.documentElement.scrollHeight;
    const floatNavbar = document.querySelector('.float-navbar');
    const stickyAddCart = document.querySelector('.sticky-add-cart');

    if (floatNavbar) {
      if (scrollTop >= 81 && scrollTop < documentHeight - windowHeight - 100) {
        floatNavbar.classList.add('active-nav');
      } else {
        floatNavbar.classList.remove('active-nav');
      }
    }
    if (stickyAddCart) {
      if (scrollTop < documentHeight - windowHeight - 100) {
        stickyAddCart.classList.remove('hide-nav');
      } else {
        stickyAddCart.classList.add('hide-nav');
      }
    }
  });

  const sortButton = document.querySelector('.sort-button');
  const sortPopup = document.querySelector('.sort-popup');
  sortButton?.addEventListener('click', function (event) {
    event.stopPropagation();
    sortPopup?.classList.toggle('show');
  });
  document.addEventListener('click', function () {
    sortPopup?.classList.remove('show');
  });
  sortPopup?.addEventListener('click', function (event) {
    event.stopPropagation();
  });
  const filterButton = document.getElementById('filter-button');
  if (filterButton) {
    filterButton.addEventListener('click', function () {
      document.getElementById('button-show-filter-mobil-js')?.click();
    });
  }
});

// change design product page mobile
let active = false

const init = () => {
  active = true
  const changeSite = () => {
    const stars = document.querySelectorAll(
      ".product-content-js .shopify-block.shopify-app-block"
    )[0];
    if (stars) {
      const reviewsPriceStar = document.createElement("div");
      reviewsPriceStar.appendChild(stars);
      clearInterval(intervalo);
    }
  };
  let intervalo = setInterval(changeSite, 1000);

  // ELEMENT OF DOM
  const title = document.querySelector(".product-content-js .title-with-price-container");
  const price = document.querySelectorAll(".product-content-js .c-price")
  const freDelivery = document.querySelector(".product-content-js .c-product__shipping");
  const freDeliveryFirst = freDelivery.cloneNode(true);
  const shippingJS = document.querySelector('.k-button.button--full-width.k-button--secondary + .shipping-js');
  shippingJS.appendChild(freDeliveryFirst);
  shippingJS.classList.remove("element-loading");

  freDelivery.style.display = "none";
  price[0].classList.add("price-custom")

  const reviewsPriceJS = document.querySelector(".product-content-js .reviews-price-js");
  setTimeout(() => {
    reviewsPriceJS.appendChild(reviewsPrice);
    reviewsPriceJS.classList.remove("element-loading");
    stampedBadge.classList.add("element-show");
  }, 500);
}


function obtenerAnchoPagina() {
  var anchoPagina = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
  if (anchoPagina <= 750 && active === false) {
    init()
  }
}

// add event listener to resize
window.addEventListener("resize", obtenerAnchoPagina);
// call function on load
window.addEventListener("load", obtenerAnchoPagina);

//remove empty li page search
document.querySelectorAll('li[data-cy-item-result]').forEach(item => {
  if (item.innerHTML.trim() === '') item.remove();
});

// CTA customize PDP
const personalizationOpenButton = document.querySelector('kl-personalize [data-klp-open]');
document.querySelectorAll('.card-overlay').forEach(element => {
  if (!personalizationOpenButton) {
    element.remove();
    return;
  }
  element.style.display = 'block';
  element.addEventListener('click', function () {
    personalizationOpenButton.click();
  });
});

document.addEventListener('DOMContentLoaded', () => {
  const elements = document.querySelectorAll('.shopify-section-group-header-group');
  if (elements.length > 1) {
    elements[1].classList.add('second-element');
  }
});

const currentURL = window.location.href;
document.querySelectorAll('.side-menu__item-link').forEach(link => {
  if (currentURL.includes(link.href)) {
    link.parentElement.classList.add('active');
  }
});

const kingshipEl = document.getElementById('kingship');
if (kingshipEl) {
  kingshipEl.addEventListener('click', function () {
    if (this.checked) {
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ quantity: 1, id: 40387992715455 }),
      })
        .then(r => r.json())
        .then(() => refreshCartDrawer())
        .catch(e => console.error(e));
    } else {
      let updates = { 40387992715455: 0 };
      fetch(window.Shopify.routes.root + 'cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ updates }),
      })
        .then(() => refreshCartDrawer())
        .catch(e => console.error('Error updating product in cart:', e));
    }
  });
}

const checkoutEl = document.getElementById('CartDrawer-Checkout');
if (checkoutEl) {
  checkoutEl.addEventListener('click', function (e) {
    e.preventDefault();
    let formData = {
      items: [{ id: 40387992715455, quantity: 1 }]
    };
    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(formData)
    }).then((response) => response.json())
      .catch(function (err) {
        console.error("Error occurred", err);
      });
  });
}

// Helper para actualizar el cart drawer
function refreshCartDrawer() {
  fetch(`${routes.cart_url}?section_id=cart-drawer`)
    .then((response) => response.text())
    .then((responseText) => {
      const html = new DOMParser().parseFromString(responseText, 'text/html');
      const selectors = ['cart-drawer-items', '.cart-drawer__footer'];
      for (const selector of selectors) {
        const targetElement = document.querySelector(selector);
        const sourceElement = html.querySelector(selector);
        if (targetElement && sourceElement) {
          targetElement.replaceWith(sourceElement);
        }
      }
    })
    .catch((e) => {
      console.error(e);
    });
}

document.querySelectorAll('.options-variants select').forEach(select => {
  select.addEventListener('change', function () {
    setTimeout(() => {
      document.querySelector('.drawer__upsell .swiper-slide-active .colors-js:not(.hidden)')?.click();
      document.querySelector('.drawer__upsell .swiper-slide-next .colors-js:not(.hidden)')?.click();
    }, 500);
  });
});

const engravingInput = document.getElementById('engraving-input');
if (engravingInput) {
  engravingInput.addEventListener('input', function () {
    const regex = /^[\u0000-\u007F\u0080-\u00FF\u0100-\u017F\u0180-\u024F]*$/;
    let value = this.value;
    if (!regex.test(value)) {
      this.value = value.replace(/[^\u0000-\u007F\u0080-\u00FF\u0100-\u017F\u0180-\u024F]/g, '');
    }
  });
}


document.addEventListener("DOMContentLoaded", function () {
  // --- Toggle Trackable Button ---
  let isTrackable = false;
  const toggleButton = document.getElementById("toggleButton");

  if (toggleButton) {
    toggleButton.addEventListener("click", function () {
      isTrackable = !isTrackable;
      this.firstElementChild.classList.toggle("on", isTrackable);

      const trackableInput = document.querySelector('input[value="Trackable"]');
      const supremeInput = document.querySelector('input[value="Supreme"]');

      if (isTrackable && trackableInput) {
        trackableInput.click();
      } else if (!isTrackable && supremeInput) {
        supremeInput.click();
      }
    });
  }

  // --- Función para inicializar el slider ---
  function initializeCustomSlider(images) {
    const mainWrapper = document.getElementById('main-swiper-wrapper');
    const thumbWrapper = document.getElementById('thumb-swiper-wrapper');
    if (!mainWrapper || !thumbWrapper) {
      console.warn('Swiper wrappers not found');
      return;
    }

    mainWrapper.innerHTML = '';
    thumbWrapper.innerHTML = '';

    images.forEach((img, index) => {
      const uniqueId = `custom-slide-${index}`;

      // MAIN SLIDE (con Fancybox)
      const li = document.createElement('li');
      li.className = 'swiper-slide';
      li.id = `Slide-${uniqueId}`;
      li.setAttribute('data-media-id', uniqueId);
      li.setAttribute('role', 'group');
      li.setAttribute('aria-label', `${index + 1} / ${images.length}`);
      li.setAttribute('style', 'width: 528px; margin-right: 10px;');
      li.setAttribute('thumbnail-color', img.alt || '');

      li.innerHTML = `
        <div class="product-media-container media-type-image media-fit-contain constrain-height" style="--ratio: 1.0; --preview-ratio: 1.0;">
          <a href="${img}" data-fancybox="gallery" class="product__media media media--transparent" title="${img.alt || ''}">
            <img src="${img}" alt="${img.alt || ''}" loading="lazy" class="image-magnify-lightbox" />
          </a>
        </div>
      `;
      mainWrapper.appendChild(li);

      // THUMB SLIDE (sin Fancybox)
      const thumbLi = document.createElement('li');
      thumbLi.className = 'swiper-slide';
      thumbLi.id = `Thumb-${uniqueId}`;
      thumbLi.setAttribute('data-media-id', uniqueId);
      thumbLi.setAttribute('role', 'group');
      thumbLi.setAttribute('aria-label', `${index + 1} / ${images.length}`);
      thumbLi.setAttribute('style', 'width: 72px; margin-right: 8px;');
      thumbLi.innerHTML = `
        <div class="product-media-thumb">
          <img src="${img}" alt="${img.alt || ''}" loading="lazy" />
        </div>
      `;
      thumbWrapper.appendChild(thumbLi);
    });

    if (typeof initSwipers === 'function') {
      initSwipers();
    }
  }

  window.initializeCustomSlider = initializeCustomSlider;
  // --- Flag global para evitar dobles ejecuciones ---
  let intelligemsTestRun = false;
  // --- Mantén la referencia al Swiper anterior ---
  window.myCustomSlider = null;

  function runIntelligemsTest() {
    // Ejecutar solo una vez por carga (o AJAX)
    if (intelligemsTestRun) return;
    intelligemsTestRun = true;

    const testGroup = window.igData?.user?.getTestGroup("acc19760-1d78-4ea4-82c1-4c8f3aebaf70");
    const idTestIntelligems = testGroup ? testGroup.id : null;

    if (idTestIntelligems === 'b2eab2cc-37ee-4bea-befd-e47b5d2d7e53') {
      // Ejecutar solo si encuentra el grupo correcto
      const scriptTag = document.querySelector('.images-test');
      if (scriptTag) {
        try {
          const parsedImages = JSON.parse(scriptTag.textContent);
          window.customVariantImages = parsedImages;

          // Destruir slider anterior si existe (Swiper)
          if (window.myCustomSlider && window.myCustomSlider.destroy) {
            window.myCustomSlider.destroy(true, true);
          }

          // Crear el slider y guardar la instancia globalmente
          window.myCustomSlider = initializeCustomSlider(parsedImages);

        } catch (e) {
          console.error('Initial load error:', e);
        }
      }
    }
  }

  function waitForIntelligemsAndRunTest(maxWait = 6000) {
    const start = Date.now();
    (function check() {
      if (window.igData && window.igData.user && typeof window.igData.user.getTestGroup === 'function') {
        runIntelligemsTest();
      } else if (Date.now() - start < maxWait) {
        setTimeout(check, 100);
      } else {
        console.warn('Intelligems no se cargó a tiempo');
      }
    })();
  }

  // Llama esto al cargar la página, o tras AJAX
  waitForIntelligemsAndRunTest();

});


document.addEventListener('DOMContentLoaded', function () {
  // Si NO estás en una página de producto, borra la clave
  if (!window.location.pathname.startsWith('/products/')) {
    localStorage.removeItem('pdp_origin-two'); // o la(s) clave(s) que quieras borrar
    localStorage.removeItem('pdp_origin');
  }
});


document.addEventListener('DOMContentLoaded', () => {
  const selected = document.querySelector('input[name="Style"]:checked');
  if (!selected) return;

  const nylonTab = document.querySelector('.custom-tabs-pdp .item.nylon');
  const leatherTab = document.querySelector('.custom-tabs-pdp .item.leather');

  if (selected.value.includes('Leather & Nylon')) {
    if (nylonTab) nylonTab.click();
  } else if (selected.value.includes('100% Leather')) {
    if (leatherTab) leatherTab.click();
  }
});